import { useMemo } from "react";

import { Flex } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import companiesListSelector from "@/store/companiesList/companiesList.selectors";

import { ButtonBlock } from "./innerComponents/ButtonBlock";
import { FiltersPanel } from "./innerComponents/FiltersPanel";
import { PanelSelector } from "./innerComponents/PanelSelector";
import { mockDataCompaniesFilters } from "./mocksData/mockDataPanels";

export const FiltersBlockModal = ({ controlModal }) => {
  const filtersList = useSelector(companiesListSelector.getFiltersList());

  const currentPanel = useSelector(
    companiesListSelector.getCurrentFiltersPanel()
  );

  const currentFiltersBlocks = useMemo(() => {
    if (filtersList?.length) {
      return mockDataCompaniesFilters({ filtersList });
    }
  }, [filtersList]);

  const styleFlex = {
    w: "full",
    h: "full",
    flexDir: "column",
    gap: "12px",
    align: "center",
    justify: { base: "flex-start", md: "center" },
  };

  return (
    <Flex {...styleFlex}>
      <PanelSelector />
      <ButtonBlock
        {...{
          controlModal,
          styleFlexWrapper: { display: { base: "flex", md: "none" } },
        }}
      />
      <FiltersPanel
        {...{ currentFiltersBlock: currentFiltersBlocks?.[currentPanel] }}
      />
      <ButtonBlock
        {...{
          controlModal,
          styleFlexWrapper: { display: { base: "none", md: "flex" } },
        }}
      />
    </Flex>
  );
};
